<template>
  <div class="container">
    <h1>Editace obrábění</h1>
  </div>
</template>

<script>
export default {
  name: "AdminActionsView"
}
</script>

<style scoped>
</style>